export const manageJourneysQueryKey = (search: string) => ['manage-journeys', search];
export const manageJourneysQueryKeyPrefix = ['manage-journeys'];
export const journeyConfigQueryKey = (journeyId: string) => ['journey-config', journeyId];
